import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { AdminTextListPage } from 'pages/admin-text-list/admin-text-list';

@NgModule({
    declarations: [AdminTextListPage],
    imports: [PagesModule, ComponentsModule],
    exports: [AdminTextListPage]
})
export class AdminTextListPageModule {}
